import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { Routes } from '../../routes/routes';
import { PageContainer } from '../PageContainer/PageContainer';
import { useDarkMode } from '../../hooks/useDarkMode/useDarkMode';
import darkTheme from '../../themes/darkTheme';
import defaultTheme from '../../themes/defaultTheme';

export const App = () => {
  const { isDarkMode } = useDarkMode();
  const [theme, setTheme] = useState();

  useEffect(() => {
    isDarkMode ? setTheme(darkTheme) : setTheme(defaultTheme);
  }, [isDarkMode]);

  if (!theme) {
    return;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PageContainer>
        <Routes />
      </PageContainer>
    </ThemeProvider>
  );
};
